// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__3ebt8","wrapper":"Tabs_wrapper__1cAOe","names":"Tabs_names__3pKCa","name":"Tabs_name__336p9","active":"Tabs_active__9Lv6q"};